module.exports=[
  {
    "nom": "Affaires Culturelles Ville Des Sables D'Olonne",
    "adresse": "21, place du Poilu de France",
    "codepostal": 85108,
    "ville": "Les Sables d'Olonne",
    "www": "http://www.lessablesdolonne.fr",
    "mail": "jean-christophe.lheuillier@lessablesdolonne.fr",
    "telephone": "0251231660",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "3-1078343",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 55,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 6000,
    "diffusion_departement": 85,
    "diffusion_epci": 200071165,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200071165,
    "actionculturelle_commune": "",
    "coords": [
      46.4971096,
      -1.78378326617871
    ]
  },
  {
    "nom": "Atelier De L'Ourse Bleue",
    "adresse": "20 bis, rue des Lices",
    "codepostal": 49000,
    "ville": "Angers",
    "www": "http://www.oursebleue.fr",
    "mail": "contact.aug@orange.fr",
    "telephone": "0642267573",
    "type": "Entreprise au sein d'une coopérative",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900015,
    "actionculturelle_commune": "",
    "coords": [
      47.4685214,
      -0.5541406
    ]
  },
  {
    "nom": "Centre Culturel Athéna",
    "adresse": "Avenue général De Gaulle",
    "codepostal": 72400,
    "ville": "La Ferté-Bernard",
    "www": "https://www.la-ferte-bernard.fr",
    "mail": "",
    "telephone": "0243714669",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1085492\n2-1085490\n3-1085493",
    "reseaux": "Réseau JP Sarthe\nPÉCANS",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 4,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 25,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 5000,
    "diffusion_departement": 72,
    "diffusion_epci": 247200686,
    "diffusion_commune": 72132,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200686,
    "actionculturelle_commune": "",
    "coords": [
      48.1827359,
      0.6473614
    ]
  },
  {
    "nom": "Centre Culturel De La Sarthe",
    "adresse": "route de Changé",
    "codepostal": 72530,
    "ville": "Yvré l'Evêque",
    "www": "http://prieuredevivoin.sarthe.com/",
    "mail": "",
    "telephone": "0243842229",
    "type": "Établissement public",
    "conventionnement": "",
    "licence": "1-1052042\n2-1052044\n3-1052045",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Momo Festival",
    "diffusion_total": 10,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 5,
    "diffusion_places_jp": 495,
    "diffusion_departement": 72,
    "diffusion_epci": 200072700,
    "diffusion_commune": 72380,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      48.0078708,
      0.2745443
    ]
  },
  {
    "nom": "Centre Culturel L'Echiquier",
    "adresse": "La Fournière",
    "codepostal": 85700,
    "ville": "Pouzauges",
    "www": "http://www.echiquier-paysdepouzauges.fr",
    "mail": "echiquier.paysdepouzauges@wanadoo.fr",
    "telephone": "0251614611",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "1-1078350\n2-1078351\n3-1078352",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Drôles de Bobines",
    "diffusion_total": 29,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 4107,
    "diffusion_departement": 85,
    "diffusion_epci": 248500621,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500464,
    "actionculturelle_commune": "",
    "coords": [
      46.7749451,
      -0.8494283
    ]
  },
  {
    "nom": "Cie Et Ecole De Cirque Mimulus",
    "adresse": "Place de la Gare",
    "codepostal": 72130,
    "ville": "Fresnay-sur-Sarthe",
    "www": "http://www.mimulus",
    "mail": "scolaire-mimulus@orange.fr",
    "telephone": "0243336944",
    "type": "Association",
    "conventionnement": "",
    "licence": "1-1057710\n1-1057711\n2-1024131\n3-1057712",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 6,
    "diffusion_jp": 2,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 2400,
    "diffusion_departement": 72,
    "diffusion_epci": 200072700,
    "diffusion_commune": 72138,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 200072700,
    "actionculturelle_commune": 72138,
    "coords": [
      48.280659,
      0.02944
    ]
  },
  {
    "nom": "Communauté De Communes Du Pays De Craon",
    "adresse": "Rue de Buchenberg B.P.71",
    "codepostal": 53400,
    "ville": "Craon",
    "www": "http://www.paysdecraon.fr",
    "mail": "",
    "telephone": "0243091989",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "1-1112521\n2-1112522\n3-1112523",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 21,
    "diffusion_jp": 11,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 5000,
    "diffusion_departement": 53,
    "diffusion_epci": 200048551,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 200048551,
    "actionculturelle_commune": "",
    "coords": [
      47.842866,
      -0.967504
    ]
  },
  {
    "nom": "Communauté De Communes Du Pays Des Herbiers",
    "adresse": "6 rue du Tourniquet",
    "codepostal": 85500,
    "ville": "Les Herbiers",
    "www": "",
    "mail": "anne.ratouit@cc-paysdesherbiers.fr",
    "telephone": "0251664239",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 7,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 3500,
    "diffusion_departement": 85,
    "diffusion_epci": 248500621,
    "diffusion_commune": 85301,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500621,
    "actionculturelle_commune": 85301,
    "coords": [
      46.8691045,
      -1.0130236
    ]
  },
  {
    "nom": "Communauté De Communes Erdre Et Gesvres",
    "adresse": "1 rue Marie Curie - PA La Grande Haie",
    "codepostal": 44119,
    "ville": "Grandchamp des Fontaines",
    "www": "http://www.hors-saison.fr",
    "mail": "",
    "telephone": "0228022252",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "2-1078421\n3-1078422",
    "reseaux": "Scène d'Enfance - Assitej France\nCollectif des médiateurs jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 1,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 1,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Le Tout-petit Festival",
    "diffusion_total": 15,
    "diffusion_jp": 15,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 7,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 6363,
    "diffusion_departement": 44,
    "diffusion_epci": 244400503,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400503,
    "actionculturelle_commune": "",
    "coords": [
      47.374531,
      -1.64663
    ]
  },
  {
    "nom": "Communauté De Communes Lbn",
    "adresse": "24 rue du pont de 4 metres",
    "codepostal": 72540,
    "ville": "Loué",
    "www": "http://www.culturelbn.fr",
    "mail": "culture@cc-lbn.fr",
    "telephone": "0272880037",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "2-1075660\n3-1075661",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 17,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 5,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1790,
    "diffusion_departement": 72,
    "diffusion_epci": 200040475,
    "diffusion_commune": 72239,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 200040475,
    "actionculturelle_commune": "",
    "coords": [
      47.994555,
      -0.158881
    ]
  },
  {
    "nom": "Communauté De Communes Pays De Chantonnay",
    "adresse": "65 av. du Général de Gaulle",
    "codepostal": 85110,
    "ville": "Chantonnay",
    "www": "http://www.cc-paysdechantonnay.fr",
    "mail": "",
    "telephone": "0251944023",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "3-1075758",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 4,
    "diffusion_jp": 3,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1300,
    "diffusion_departement": 85,
    "diffusion_epci": 248500340,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500340,
    "actionculturelle_commune": "",
    "coords": [
      46.6925884,
      -1.049817
    ]
  },
  {
    "nom": "Communaute De Communes Vendee Sevre Autise",
    "adresse": "25 rue de la Gare",
    "codepostal": 85420,
    "ville": "Oulmes",
    "www": "http://www.cc-vsa.com",
    "mail": "culture@cc-vsa.com",
    "telephone": "0251504880",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "2-1080596\n3-1080597",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 11,
    "diffusion_jp": 6,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 600,
    "diffusion_departement": 85,
    "diffusion_epci": 248500563,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500563,
    "actionculturelle_commune": "",
    "coords": [
      46.4101831,
      -0.6805809
    ]
  },
  {
    "nom": "Commune De Beaufort-En-Anjou",
    "adresse": "16 rue de l'hôtel de ville",
    "codepostal": 49250,
    "ville": "Beaufort-en-anjou",
    "www": "",
    "mail": "",
    "telephone": "0241793613",
    "type": "Commune",
    "conventionnement": "",
    "licence": "3-1101328",
    "reseaux": "PJP 49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festi'pousses",
    "diffusion_total": 12,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 900,
    "diffusion_departement": 49,
    "diffusion_epci": 244900882,
    "diffusion_commune": 49201,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900882,
    "actionculturelle_commune": 49201,
    "coords": [
      47.4404999,
      -0.215733
    ]
  },
  {
    "nom": "Commune De Changé",
    "adresse": "Hôtel de ville, 6 place Christian d'Elva",
    "codepostal": 53810,
    "ville": "Changé",
    "www": "http://www.culture-change53.fr",
    "mail": "",
    "telephone": "0243533442",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1094272\n2-1094273\n3-1094274",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 23,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 4,
    "diffusion_places_jp": 850,
    "diffusion_departement": 53,
    "diffusion_epci": 245300330,
    "diffusion_commune": 53054,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 245300330,
    "actionculturelle_commune": 53054,
    "coords": [
      48.09863845,
      -0.788661573109924
    ]
  },
  {
    "nom": "Direction Des Affaires Culturelles",
    "adresse": "Le Cyel, 10 rue Salvador Allende",
    "codepostal": 85000,
    "ville": "La Roche sur Yon",
    "www": "http://www.larochesuryon.fr",
    "mail": "",
    "telephone": "0251474907",
    "type": "Ville",
    "conventionnement": "",
    "licence": "1-1112685\n1-1112684\n1-1112686\n2-1112687\n3-1112688",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 5,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 3,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Les concerts très tôt",
    "diffusion_total": 51,
    "diffusion_jp": 6,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1900,
    "diffusion_departement": 85,
    "diffusion_epci": 248500589,
    "diffusion_commune": 85000,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500589,
    "actionculturelle_commune": 85000,
    "coords": [
      46.670427,
      -1.431175
    ]
  },
  {
    "nom": "Espace Culturel René Cassin-La Gare",
    "adresse": "avenue de la Gare",
    "codepostal": 85200,
    "ville": "Fontenay-le-comte",
    "www": "http://www.fontenaylecomte.fr",
    "mail": "ecc.r.cassin@ville-fontenaylecomte.fr",
    "telephone": "0251000500",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1080706\n1-1105630\n3-1080708",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 20,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 5,
    "diffusion_places_jp": 4140,
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200071934,
    "actionculturelle_commune": 85092,
    "coords": [
      46.4622697,
      -0.7943181
    ]
  },
  {
    "nom": "Espace Culturel Scelia",
    "adresse": "Rue Didier Pironi",
    "codepostal": 72190,
    "ville": "Sargé-Lès-Le Mans",
    "www": "http://www.sargeleslemans.fr",
    "mail": "scelia@sargeleslemans.fr",
    "telephone": "0243763850",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "3-1042023\n1-1042022",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Pays du Môme\nRendez vous pour les p'tits Queniaux",
    "diffusion_total": 16,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1200,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": 72328,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": 72328,
    "coords": [
      48.0356169,
      0.2417959
    ]
  },
  {
    "nom": "Espace Saugonna",
    "adresse": "2 rue de la Gare",
    "codepostal": 72600,
    "ville": "Mamers",
    "www": "",
    "mail": "",
    "telephone": "0243337790",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "1-1101333",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 18,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 4663,
    "diffusion_departement": 72,
    "diffusion_epci": 200072676,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 200072676,
    "actionculturelle_commune": "",
    "coords": [
      48.347135,
      0.364821
    ]
  },
  {
    "nom": "Graines D'Images",
    "adresse": "35, rue de Degré - hall A",
    "codepostal": 72000,
    "ville": "Le Mans",
    "www": "http://www.grainesdimages.com",
    "mail": "graines.dimages@wanadoo.fr",
    "telephone": "0243782501",
    "type": "Réseau de salles de cinéma",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Graines d'Images Junior",
    "diffusion_total": 0,
    "diffusion_jp": 0,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 0,
    "diffusion_departement": 72,
    "diffusion_epci": 247200686,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200686,
    "actionculturelle_commune": "",
    "coords": [
      48.019064,
      0.173756
    ]
  },
  {
    "nom": "Ici Ou Là, Service Culturel De La Ville D'Indre",
    "adresse": "1 avenue de la Loire",
    "codepostal": 44610,
    "ville": "Indre",
    "www": "http://www.ici-ou-la.fr",
    "mail": "",
    "telephone": "0240854574",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "2-1085562\n3-1085563",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 15,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 842,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44074,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44074,
    "coords": [
      47.1979752,
      -1.6637588
    ]
  },
  {
    "nom": "La 3'E Saison De L'Ernée",
    "adresse": "Cté de communes de l'Ernée - ZA de la Querminais - BP 28",
    "codepostal": 53500,
    "ville": "Ernée",
    "www": "http://www.cc-lernee.fr",
    "mail": "a.mandagot@lernee.fr",
    "telephone": "0243059887",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "3-1059176",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 1,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 17,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 5100,
    "diffusion_departement": 53,
    "diffusion_epci": 245300355,
    "diffusion_commune": 53269,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 245300355,
    "actionculturelle_commune": 53269,
    "coords": [
      48.288472,
      -0.922085
    ]
  },
  {
    "nom": "La Bouche D'Air",
    "adresse": "33 rue de strasbourg",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.labouchdair.com",
    "mail": "",
    "telephone": "0240734020",
    "type": "Association",
    "conventionnement": "",
    "licence": "2-1034552\n3-1034553",
    "reseaux": "RAMDAM",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 0,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 52,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 3806,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44109,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44109,
    "coords": [
      47.2193637,
      -1.5542702
    ]
  },
  {
    "nom": "La Boussole - Médiathèque De La Barre De Monts",
    "adresse": "2, Chemin du Querruy",
    "codepostal": 85550,
    "ville": "La Barre de Monts",
    "www": "http://www.bibliotheques-omdm.fr",
    "mail": "bibliotheque.mairie@ville-labarredemonts.fr",
    "telephone": "0251688486",
    "type": "Médiathèque",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500258,
    "actionculturelle_commune": 85012,
    "coords": [
      46.8851524,
      -2.1193078
    ]
  },
  {
    "nom": "La Soufflerie",
    "adresse": "2 Avenue de Bretagne",
    "codepostal": 44400,
    "ville": "Rezé",
    "www": "http://www.lasoufflerie.org",
    "mail": "",
    "telephone": "0251707801",
    "type": "Scène conventionnée",
    "conventionnement": "Voix",
    "licence": "1-1091646\n2-1091647\n3-1091648",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 60,
    "diffusion_jp": 6,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2590,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": "",
    "coords": [
      47.1853181,
      -1.5550563
    ]
  },
  {
    "nom": "Le Carroi",
    "adresse": "Espace Montréal",
    "codepostal": 72200,
    "ville": "La Flèche",
    "www": "http://www.lecarroi.org",
    "mail": "",
    "telephone": "0243940899",
    "type": "Centre socioculturel",
    "conventionnement": "",
    "licence": "2-1057556\n3-1057557",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Malices au Pays",
    "diffusion_total": 28,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 6,
    "diffusion_6_12ans": 14,
    "diffusion_12ans": 15,
    "diffusion_places_jp": 3300,
    "diffusion_departement": 72,
    "diffusion_epci": 247200348,
    "diffusion_commune": 72154,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200348,
    "actionculturelle_commune": 72154,
    "coords": [
      47.699299,
      -0.073327
    ]
  },
  {
    "nom": "Le Grand R",
    "adresse": "Esplanade Jeannie-Mazurelle, Rue Pierre-Bérégovoy – BP 681",
    "codepostal": 85017,
    "ville": "La Roche-sur-Yon",
    "www": "http://www.legrandr.com",
    "mail": "contact@legrandr.com",
    "telephone": "0251478380",
    "type": "Scène nationale",
    "conventionnement": "",
    "licence": "1-1075762\n1-1075763\n1-1075764\n2-1075765\n3-1075766",
    "reseaux": "Collectif des médiateurs jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 13,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 48,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 6834,
    "diffusion_departement": 85,
    "diffusion_epci": 248500589,
    "diffusion_commune": 85213,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500589,
    "actionculturelle_commune": 85191,
    "coords": [
      46.668682,
      -1.429985
    ]
  },
  {
    "nom": "Le Grand T",
    "adresse": "84 rue du Général Buat - BP 30111",
    "codepostal": 44011,
    "ville": "Nantes",
    "www": "http://www.leGrandT.fr",
    "mail": "prog.jeunepublic@legrandt.fr",
    "telephone": "0251882525",
    "type": "Scène conventionnée",
    "conventionnement": "Théâtre",
    "licence": "1-1075853\n1-1075850\n2-1075851\n3-1075852",
    "reseaux": "Scène d'Enfance - Assitej France\nCollectif des médiateurs jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 72,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 1,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Petits en Grands",
    "diffusion_total": 54,
    "diffusion_jp": 11,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 6,
    "diffusion_places_jp": 22703,
    "diffusion_departement": 44,
    "diffusion_epci": 244400644,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400610,
    "actionculturelle_commune": "",
    "coords": [
      47.231373,
      -1.540397
    ]
  },
  {
    "nom": "Le Kiosque - Centre D'Action Culturelle - Mayenne Communauté",
    "adresse": "7/9 Place Juhel - BP 50433",
    "codepostal": 53104,
    "ville": "Mayenne",
    "www": "http://www.kiosque-mayenne.org/",
    "mail": "",
    "telephone": "0243301016",
    "type": "Association",
    "conventionnement": "",
    "licence": "2-1022328\n3-1022330",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 11,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 3,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "53 tours",
    "diffusion_total": 21,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 3200,
    "diffusion_departement": 53,
    "diffusion_epci": 200055887,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 200055887,
    "actionculturelle_commune": "",
    "coords": [
      48.30226,
      -0.619653
    ]
  },
  {
    "nom": "Le Livre Dans La Théière",
    "adresse": "6 place de la Mairie",
    "codepostal": 85620,
    "ville": "Rocheserviere",
    "www": "",
    "mail": "lelivredanslatheiere@orange.fr",
    "telephone": "0251064835",
    "type": "Librairie",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200072882,
    "actionculturelle_commune": "",
    "coords": [
      46.9365,
      -1.512701
    ]
  },
  {
    "nom": "Le Quai - Cdn",
    "adresse": "17 rue de la tannerie",
    "codepostal": 49000,
    "ville": "Angers",
    "www": "http://lequai-angers.eu",
    "mail": "",
    "telephone": "0244012256",
    "type": "Centre Dramatique National",
    "conventionnement": "",
    "licence": "1-1024162\n2-1024163\n3-1024164",
    "reseaux": "PJP 49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 4,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Le Beau Samedi",
    "diffusion_total": 49,
    "diffusion_jp": 12,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 9,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 16560,
    "diffusion_departement": 49,
    "diffusion_epci": 244900015,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900015,
    "actionculturelle_commune": "",
    "coords": [
      47.4727565,
      -0.5656585
    ]
  },
  {
    "nom": "Le Théâtre, Scène Conventionnée De Laval",
    "adresse": "rue de la paix",
    "codepostal": 53000,
    "ville": "Laval",
    "www": "http://www.letheatre.laval.fr",
    "mail": "",
    "telephone": "0779803215",
    "type": "Scène conventionnée",
    "conventionnement": "Arts de la marionnette et formes animées",
    "licence": "",
    "reseaux": "Collectif des médiateurs jeune public des Pays de la Loire\nPlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 0,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 40,
    "diffusion_jp": 18,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 5,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 5,
    "diffusion_places_jp": 6000,
    "diffusion_departement": 53,
    "diffusion_epci": 245300330,
    "diffusion_commune": 53130,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 245300330,
    "actionculturelle_commune": 53130,
    "coords": [
      48.0709941,
      -0.7691566
    ]
  },
  {
    "nom": "Le Val'Rhonne",
    "adresse": "Allée de l'Europe",
    "codepostal": 72330,
    "ville": "Moncé-en-Belin",
    "www": "http://www.valrhonne.org/",
    "mail": "valrhonne@wanadoo.fr",
    "telephone": "0243422948",
    "type": "Centre Socioculturel",
    "conventionnement": "",
    "licence": "1-1087751\n2-1087776\n3-1087775",
    "reseaux": "Collectif Pays du môme",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 13,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1700,
    "diffusion_departement": 72,
    "diffusion_epci": 247200447,
    "diffusion_commune": 72200,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.8929673,
      0.2011817
    ]
  },
  {
    "nom": "Les Quinconces-L'Espal",
    "adresse": "4 place des Jacobins",
    "codepostal": 72000,
    "ville": "Le Mans",
    "www": "http://www.quinconces-espal.com",
    "mail": "",
    "telephone": "0243502150",
    "type": "Scène nationale",
    "conventionnement": "",
    "licence": "1-146369\n2-146370\n3-146371",
    "reseaux": "Réseau JP Sarthe\nCollectif des médiateurs jeune public des Pays de la Loire\nPlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 5,
    "aidecreation_coprod": 0,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival en jeu !",
    "diffusion_total": 52,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 8000,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": 72181,
    "coords": [
      48.0076541,
      0.1988369
    ]
  },
  {
    "nom": "Ligue De L'Enseignement De La Mayenne",
    "adresse": "31 allée du vieux saint louis",
    "codepostal": 53000,
    "ville": "Laval",
    "www": "http://www.laligue53.org",
    "mail": "charlene.mur@laligue53.org",
    "telephone": "0252460127",
    "type": "Association",
    "conventionnement": "",
    "licence": "2-1080632\n3-1080633",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 9,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 7500,
    "diffusion_departement": 53,
    "diffusion_epci": 245300306,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      48.0718691,
      -0.7733292
    ]
  },
  {
    "nom": "Mairie Des Sorinières",
    "adresse": "les sorinières",
    "codepostal": 44840,
    "ville": "Les Sorinières",
    "www": "http://www.ville-sorinieres.fr/",
    "mail": "culture@ville-sorinieres.fr",
    "telephone": "0240130000",
    "type": "Commune",
    "conventionnement": "",
    "licence": "1-1046937\n3-1046938",
    "reseaux": "Réseau des programmateurs jeune public 44",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Je sors mes parents",
    "diffusion_total": 8,
    "diffusion_jp": 3,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 186,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44198,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44198,
    "coords": [
      47.1485792,
      -1.5332052
    ]
  },
  {
    "nom": "Médiathèque Venansault",
    "adresse": "l'îlot des Arts - Place de la Billardière",
    "codepostal": 85190,
    "ville": "Venansault",
    "www": "http://mediatheque-venansault.blogspot.com/",
    "mail": "",
    "telephone": "0251481936",
    "type": "Médiathèque",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 248500589,
    "actionculturelle_commune": 85300,
    "coords": [
      46.68498,
      -1.51145
    ]
  },
  {
    "nom": "Mjc Ronceray / L'Alambik",
    "adresse": "bd de la fresnellerie",
    "codepostal": 72100,
    "ville": "le Mans",
    "www": "http://www.mjc-ronceray.org",
    "mail": "adeline.rousseau@mjc-ronceray.org",
    "telephone": "0243725222",
    "type": "Association",
    "conventionnement": "",
    "licence": "1-1080609\n2-1080610\n3-1080611",
    "reseaux": "Réseau JP Sarthe\nCollectif Pays du môme",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festimioches\nTout-petits et déjà grands",
    "diffusion_total": 30,
    "diffusion_jp": 14,
    "diffusion_0_3ans": 3,
    "diffusion_3_6ans": 6,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 1800,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": 72181,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": 72181,
    "coords": [
      47.9699467,
      0.204411
    ]
  },
  {
    "nom": "Musique Et Danse En Loire-Atlantique",
    "adresse": "11 rue Jules Verne",
    "codepostal": 44700,
    "ville": "Orvault",
    "www": "http://www.musiqueetdanse44.asso.fr",
    "mail": "contact@md44.asso.fr",
    "telephone": "0251843888",
    "type": "Association",
    "conventionnement": "",
    "licence": "2-1110413\n3-1110414",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 48,
    "diffusion_jp": 29,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 12,
    "diffusion_12ans": 17,
    "diffusion_places_jp": 7875,
    "diffusion_departement": 44,
    "diffusion_epci": 244400644,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400586,
    "actionculturelle_commune": "",
    "coords": [
      47.2529748,
      -1.6158712
    ]
  },
  {
    "nom": "Paus Vallée Du Loir",
    "adresse": "rue Anatole Carré",
    "codepostal": 72500,
    "ville": "Vaas",
    "www": "http://www.paysvalleeduloir.fr",
    "mail": "alexandre.menard@pays-valleeduloir.fr",
    "telephone": "0243381673",
    "type": "Pays",
    "conventionnement": "",
    "licence": "3-1054181",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 4,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 2,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Malices au Pays",
    "diffusion_total": 18,
    "diffusion_jp": 10,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 6,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 5700,
    "diffusion_departement": 72,
    "diffusion_epci": 247200348,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200348,
    "actionculturelle_commune": "",
    "coords": [
      47.6681999,
      0.3139872
    ]
  },
  {
    "nom": "Pays Du Mans",
    "adresse": "4O rue de la galère",
    "codepostal": 72000,
    "ville": "Le Mans",
    "www": "http://www.paysdumans.fr",
    "mail": "patricia.chevalier@paysdumans.fr",
    "telephone": "0243512323",
    "type": "Pays",
    "conventionnement": "",
    "licence": "",
    "reseaux": "Collectif Pays du môme",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200447,
    "actionculturelle_commune": "",
    "coords": [
      48.0062913,
      0.1929769
    ]
  },
  {
    "nom": "Petits Et Grands",
    "adresse": "9, rue des Olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.petitsetgrands.net",
    "mail": "cyrille.planson@petitsetgrands.net",
    "telephone": "0621247344",
    "type": "Association",
    "conventionnement": "",
    "licence": "",
    "reseaux": "Scène d'Enfance - Assitej France\nLes Scènes appartagées",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 20,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 0,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival Petits et Grands",
    "diffusion_total": 42,
    "diffusion_jp": 42,
    "diffusion_0_3ans": 18,
    "diffusion_3_6ans": 14,
    "diffusion_6_12ans": 10,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 12000,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44109,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44109,
    "notes": "Le festival a lieu les années impaires. Ces données chiffrées concernent la saison 2016-2017",
    "coords": [
      47.2123365,
      -1.5501326
    ]
  },
  {
    "nom": "Piano'Cktail",
    "adresse": "Rue Ginsheim Gustavsburg",
    "codepostal": 44340,
    "ville": "Bouguenais",
    "www": "http://www.pianocktail-bouguenais.fr",
    "mail": "",
    "telephone": "0689321997",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1108169\n2-1108170\n3-1108171",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 35,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 6700,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44020,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": 44020,
    "coords": [
      47.1740111,
      -1.6097043
    ]
  },
  {
    "nom": "Saison Culturelle Du Mont Des Avaloirs",
    "adresse": "1 rue de la Corniche de Pail",
    "codepostal": 53140,
    "ville": "Pré-en-Pail-Saint-Samson",
    "www": "http://www.cc-montdesavaloirs.fr/la-saison-culturelle-de-la-ccma/",
    "mail": "",
    "telephone": "0243301111",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "3-1078378",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Spectacles en Chemin",
    "diffusion_total": 13,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 3,
    "diffusion_places_jp": 2285,
    "diffusion_departement": 53,
    "diffusion_epci": 200042182,
    "diffusion_commune": 53271,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 53,
    "actionculturelle_epci": 200042182,
    "actionculturelle_commune": "",
    "coords": [
      48.4566123,
      -0.2078357
    ]
  },
  {
    "nom": "Salle Vasse",
    "adresse": "18 rue Colbert",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://www.sallevasse.fr",
    "mail": "info@sallevasse.fr",
    "telephone": "0240731260",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival pour enfants sages et pas seulement",
    "diffusion_total": 80,
    "diffusion_jp": 25,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 5,
    "diffusion_12ans": 15,
    "diffusion_places_jp": 6930,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": 44109,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      47.2156023,
      -1.5690889
    ]
  },
  {
    "nom": "Service Culturel De Challans",
    "adresse": "Hotel de Ville",
    "codepostal": 85300,
    "ville": "Challans",
    "www": "https://saisonculturelle.challans.fr/",
    "mail": "",
    "telephone": "0251491899",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1042062\n1-1042063\n1-1042064\n1-1042065\n1-1042066\n2-1042067\n3-1042068",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 4,
    "aidecreation_coprod": "",
    "aidecreation_residence": 2,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 23,
    "diffusion_jp": 11,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 6,
    "diffusion_12ans": 4,
    "diffusion_places_jp": 3950,
    "diffusion_departement": 85,
    "diffusion_epci": 200071629,
    "diffusion_commune": 85047,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200071629,
    "actionculturelle_commune": 85047,
    "coords": [
      46.845009,
      -1.879335
    ]
  },
  {
    "nom": "Service Culturel Ville De Coulaines",
    "adresse": "Square Weyhe",
    "codepostal": 72190,
    "ville": "Coulaines",
    "www": "http://www.coulaines.fr",
    "mail": "culture@coulaines.fr",
    "telephone": "0243743510",
    "type": "Commune",
    "conventionnement": "",
    "licence": "1-1044012\n3-1041013",
    "reseaux": "Réseau JP Sarthe",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 10,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 4890,
    "diffusion_departement": 72,
    "diffusion_epci": 247200421,
    "diffusion_commune": 72231,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": 72095,
    "coords": [
      48.0237602,
      0.2021867
    ]
  },
  {
    "nom": "Site Saint-Sauveur",
    "adresse": "Place Saint-Sauveur",
    "codepostal": 85620,
    "ville": "Rocheservière",
    "www": "http://www.sitesaintsauveur.fr",
    "mail": "contact@sitesaintsauveur.fr",
    "telephone": "0251482356",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Non",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": "",
    "diffusion_jp": "",
    "diffusion_0_3ans": "",
    "diffusion_3_6ans": "",
    "diffusion_6_12ans": "",
    "diffusion_12ans": "",
    "diffusion_places_jp": "",
    "diffusion_departement": "",
    "diffusion_epci": "",
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200070233,
    "actionculturelle_commune": "",
    "coords": [
      46.9376985,
      -1.5097261
    ]
  },
  {
    "nom": "Théâtre De Chaoué",
    "adresse": "11 rue du moulin de Chaoué",
    "codepostal": 72700,
    "ville": "Allonnes",
    "www": "https://www.theatredechaoue.fr/",
    "mail": "contact@theatredechaoue.fr",
    "telephone": "0243804008",
    "type": "Association",
    "conventionnement": "",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 2,
    "aidecreation_coprod": 4,
    "aidecreation_residence": 6,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 21,
    "diffusion_jp": 4,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 10,
    "diffusion_places_jp": 800,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": 72003,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200132,
    "actionculturelle_commune": 72003,
    "coords": [
      47.9724101,
      0.1658002
    ]
  },
  {
    "nom": "Théâtre De L'Ephémère",
    "adresse": "8 place des Jacobins",
    "codepostal": 72000,
    "ville": "Le Mans",
    "www": "http://www.theatre-ephemere.fr",
    "mail": "contact@theatre-ephemere.fr",
    "telephone": "0243438989",
    "type": "Scène conventionnée",
    "conventionnement": "Art et création",
    "licence": "",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 12,
    "diffusion_jp": 1,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 0,
    "diffusion_6_12ans": 0,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1100,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": 72181,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 247200447,
    "actionculturelle_commune": 72181,
    "coords": [
      48.0073783,
      0.1989582
    ]
  },
  {
    "nom": "Théâtre De Thalie",
    "adresse": "Esplanade de Verdun",
    "codepostal": 85600,
    "ville": "Montaigu",
    "www": "http://www.thalie.terresdemontaigu.fr",
    "mail": "",
    "telephone": "0251092090",
    "type": "Communauté de communes",
    "conventionnement": "",
    "licence": "1-1036492\n3-1029667",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Mont'en Scène",
    "diffusion_total": 30,
    "diffusion_jp": 7,
    "diffusion_0_3ans": 0,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 3,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 4760,
    "diffusion_departement": 85,
    "diffusion_epci": 200070233,
    "diffusion_commune": 85146,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200070233,
    "actionculturelle_commune": 85146,
    "coords": [
      46.9817211,
      -1.3082603
    ]
  },
  {
    "nom": "Théâtre Du Cyclope",
    "adresse": "82 rue du Maréchal Joffre",
    "codepostal": 44000,
    "ville": "Nantes",
    "www": "http://theatreducyclope.com",
    "mail": "theatreducyclope@gmail.com",
    "telephone": "0251864507",
    "type": "Théâtre privé",
    "conventionnement": "",
    "licence": "1-1090174\n2-1090175\n3-1090176",
    "reseaux": "",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": "",
    "aidecreation_coprod": 1,
    "aidecreation_residence": 6,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "La chaussette de M. Joffre",
    "diffusion_total": 58,
    "diffusion_jp": 12,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 3,
    "diffusion_6_12ans": 8,
    "diffusion_12ans": 46,
    "diffusion_places_jp": 7252,
    "diffusion_departement": 85,
    "diffusion_epci": 248500662,
    "diffusion_commune": 44127,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 85,
    "actionculturelle_epci": 200040475,
    "actionculturelle_commune": 44068,
    "coords": [
      47.3018941,
      -1.5577515
    ]
  },
  {
    "nom": "Théâtre Épidaure",
    "adresse": "1 rue de la grosse pierre",
    "codepostal": 72440,
    "ville": "Bouloire",
    "www": "http://www.theatre-epidaure.com",
    "mail": "",
    "telephone": "0243355604",
    "type": "Association",
    "conventionnement": "",
    "licence": "1-1085541",
    "reseaux": "Collectif des médiateurs jeune public des Pays de la Loire\nRéseau JP Sarthe\nPlatO - Plateforme jeune public des Pays de la Loire\nPÉCANS",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 6,
    "aidecreation_coprod": 1,
    "aidecreation_residence": 6,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Temps fort jeunes",
    "diffusion_total": 15,
    "diffusion_jp": 11,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 1,
    "diffusion_6_12ans": 7,
    "diffusion_12ans": 2,
    "diffusion_places_jp": 4240,
    "diffusion_departement": 72,
    "diffusion_epci": 200072684,
    "diffusion_commune": 72090,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 72,
    "actionculturelle_epci": 200072692,
    "actionculturelle_commune": "",
    "coords": [
      47.973539,
      0.554081
    ]
  },
  {
    "nom": "Théâtre ONYX - Ville De Saint Herblain",
    "adresse": "1, place Océane BP 30224",
    "codepostal": 44815,
    "ville": "Saint Herblain",
    "www": "http://www.theatreonyx.fr",
    "mail": "",
    "telephone": "0228252501",
    "type": "Scène conventionnée",
    "conventionnement": "Danse et cirque",
    "licence": "1-1087704\n1-1087705\n2-1087706\n3-1087707",
    "reseaux": "Collectif des médiateurs jeune public des Pays de la Loire\nPlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 20,
    "aidecreation_coprod": 3,
    "aidecreation_residence": 4,
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Festival NIJINSKID",
    "diffusion_total": 57,
    "diffusion_jp": 13,
    "diffusion_0_3ans": 2,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 9,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 7786,
    "diffusion_departement": 44,
    "diffusion_epci": 244400404,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": 44,
    "actionculturelle_epci": 244400404,
    "actionculturelle_commune": "",
    "coords": [
      47.224004,
      -1.628445
    ]
  },
  {
    "nom": "Thv",
    "adresse": "1, rue Jean Gilles",
    "codepostal": 49180,
    "ville": "Saint-Barthélémy-d'Anjou",
    "www": "http://www.thv.fr",
    "mail": "",
    "telephone": "0241961490",
    "type": "Théâtre municipal",
    "conventionnement": "",
    "licence": "1-1029753\n2-1029754\n3-1029755",
    "reseaux": "PJP 49\nPlatO - Plateforme jeune public des Pays de la Loire",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 3,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 2,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 42,
    "diffusion_jp": 9,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 4,
    "diffusion_6_12ans": 4,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 2361,
    "diffusion_departement": 49,
    "diffusion_epci": 244900015,
    "diffusion_commune": 49267,
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Oui",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 244900015,
    "actionculturelle_commune": 49267,
    "coords": [
      47.4687573,
      -0.4959337
    ]
  },
  {
    "nom": "Villages En Scène",
    "adresse": "2, rue Jacques du Bellay",
    "codepostal": 49380,
    "ville": "Thouarcé",
    "www": "http://www.villages-en-scene.fr",
    "mail": "programmation@villages-en-scene.fr",
    "telephone": "0241541207",
    "type": "Établissement public",
    "conventionnement": "",
    "licence": "1-1108159\n2-1108160\n3-1108160",
    "reseaux": "PJP 49",
    "activite_aidecreation": "Oui",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Oui",
    "aidecreation_preachat": 3,
    "aidecreation_coprod": 2,
    "aidecreation_residence": 1,
    "diffusion_festival": "Non",
    "diffusion_festival_nom": "",
    "diffusion_total": 30,
    "diffusion_jp": 5,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1600,
    "diffusion_departement": 49,
    "diffusion_epci": 200071553,
    "diffusion_commune": "",
    "actionculturelle_scolaire": "Oui",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Oui",
    "actionculturelle_departement": 49,
    "actionculturelle_epci": 200071553,
    "actionculturelle_commune": "",
    "coords": [
      47.2664933,
      -0.5012198
    ]
  },
  {
    "nom": "Ville D'Yvré L'Evêque, Service Culture",
    "adresse": "16, avenue Guy Bouriat",
    "codepostal": 72530,
    "ville": "Yvré l'Evêque",
    "www": "http://www.yvreleveque.fr",
    "mail": "culture@yvreleveque.fr",
    "telephone": "0243896002",
    "type": "Commune",
    "conventionnement": "",
    "licence": "1-1075855\n2-1075856\n3-1075857",
    "reseaux": "Collectif Pays du môme",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "Au Pays du Môme",
    "diffusion_total": 13,
    "diffusion_jp": 8,
    "diffusion_0_3ans": 5,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 1,
    "diffusion_12ans": 0,
    "diffusion_places_jp": 860,
    "diffusion_departement": 72,
    "diffusion_epci": 247200132,
    "diffusion_commune": 72386,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      48.0128261,
      0.2694379
    ]
  },
  {
    "nom": "Ville De Saint-Hilaire-De-Riez - Service Culturel",
    "adresse": "Place de l'église, BP 49",
    "codepostal": 85270,
    "ville": "Saint-Hilaire-de-Riez",
    "www": "http://www.sainthilairederiez.fr",
    "mail": "",
    "telephone": "0251599400",
    "type": "Commune",
    "conventionnement": "",
    "licence": "1-1085423\n2-1085430 \n3-1085431",
    "reseaux": "",
    "activite_aidecreation": "Non",
    "activite_diffusion": "Oui",
    "activite_actionculturelle": "Non",
    "aidecreation_preachat": "",
    "aidecreation_coprod": "",
    "aidecreation_residence": "",
    "diffusion_festival": "Oui",
    "diffusion_festival_nom": "La Fête Dans les Nuages",
    "diffusion_total": 12,
    "diffusion_jp": 6,
    "diffusion_0_3ans": 1,
    "diffusion_3_6ans": 2,
    "diffusion_6_12ans": 2,
    "diffusion_12ans": 1,
    "diffusion_places_jp": 1620,
    "diffusion_departement": 85,
    "diffusion_epci": 200023778,
    "diffusion_commune": 85226,
    "actionculturelle_scolaire": "Non",
    "actionculturelle_periscolaire": "Non",
    "actionculturelle_extrascolaire": "Non",
    "actionculturelle_departement": "",
    "actionculturelle_epci": "",
    "actionculturelle_commune": "",
    "coords": [
      46.7205,
      -1.945929
    ]
  }
]
